__webpack_require__.p = "/cardiac-care-heart-treatment/";